import React, { useState, useEffect } from "react";
import OrgLogo from '../assets/Images/cwilogo.png';
import { signIn } from "../services/authServices";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
// import CryptoJS from "crypto-js";


export default function Signin() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        Email: '',
        Password: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [environment, setEnvironment] = useState(
        sessionStorage.getItem("API_ENVIRONMENT") || "PROD"
    );

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            sessionStorage.setItem("API_ENVIRONMENT", environment);
            
            const response = await signIn(formData);
            const result = response.data;

            if (result?.result === "success") {
                const user = result?.data?.user;

                const { Modules, ...userData } = user;
              
                const parsedModules = Modules ? JSON.parse(Modules) : [];
              
                sessionStorage.setItem("userData", JSON.stringify(userData));
                sessionStorage.setItem("accessToken", result.data.accessToken);
                sessionStorage.setItem("refreshToken", result.data.refreshToken);
              
                const hasSuperPortal = parsedModules.some(
                  (mod) => mod.ModuleName?.toLowerCase() === "superportal"
                );

                const superPortalModule = parsedModules.find(
                    (mod) => mod.ModuleName?.toLowerCase() === "superportal"
                );                  

                if (hasSuperPortal) {
                    const moduleId = superPortalModule.Id;
                    sessionStorage.setItem("ModuleId", moduleId);

                    setLoading(false);
                    navigate("/dashboard");
                } else {
                    setLoading(false);
                    Swal.fire({
                        icon: "warning",
                        title: "Access Denied",
                        text: "You don't have access to SuperPortal.",
                    });
                }
            } else {
                setLoading(false);
                Swal.fire("Error", result?.response || "Login failed", "error");
            }
        } catch (error) {
            setLoading(false);
            console.error("Login Error:", error);
            Swal.fire("Error", "Something went wrong.", "error");
        }
    };

    return (
        <>
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="login-wrapper bg-img">
                        <div className="login-content authent-content">
                            <form onSubmit={handleSubmit}>
                                <div className="login-userset">
                                    <div className="login-logo logo-normal">
                                        <img src={OrgLogo} alt="img" />
                                    </div>
                                    <a className="login-logo logo-white">
                                        <img src="assets/img/logo-white.svg" alt="Img" />
                                    </a>
                                    <div className="login-userheading">
                                        <h3>Sign In</h3>
                                        <h4 className="fs-16">Access the Admin panel using your email and passcode.</h4>
                                    </div>
                                    <div className="mb-3">
    <label className="form-label">Environment</label>

    <div className="btn-group w-100">
        <button
            type="button"
            className={`btn ${
                environment === "PROD"
                    ? "btn-primary"
                    : "btn-outline-primary"
            }`}
            onClick={() => setEnvironment("PROD")}
            disabled={loading}
        >
            Production
        </button>

        <button
            type="button"
            className={`btn ${
                environment === "QA"
                    ? "btn-primary"
                    : "btn-outline-primary"
            }`}
            onClick={() => setEnvironment("QA")}
            disabled={loading}
        >
            QA
        </button>
    </div>
</div>
                                    <div className="mb-3">
                                        <label className="form-label">Email <span className="text-danger"> *</span></label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control border-end-0"
                                                name="Email"
                                                value={formData.Email}
                                                onChange={handleChange}
                                                placeholder="Enter Email"
                                                disabled={loading}
                                            />
                                            <span className="input-group-text border-start-0">
                                                <i className="ti ti-user"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Password <span className="text-danger"> *</span></label>
                                        <div className="input-group">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control border-end-0"
                                                name="Password"
                                                value={formData.Password}
                                                onChange={handleChange}
                                                placeholder="Enter password"
                                                disabled={loading}
                                            />
                                            <span
                                                className="input-group-text border-start-0"
                                                onClick={handleTogglePassword}
                                            >
                                                <i className={`fa-regular ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-login authentication-check">
                                        <div className="row">
                                            <div className="col-12 d-flex align-items-center justify-content-between">
                                                <div className="custom-control custom-checkbox">
                                                    <label className="checkbox-container ps-4 mb-0 pb-0 fs-16 text-gray-6">
                                                        Remember me
                                                        <input type="checkbox" disabled={loading} />
                                                        <span className="checkmark"></span>
                                                    </label>

                                                </div>
                                                <div className="text-end">
                                                    <a className="text-orange fs-16 fw-medium" disabled={loading}>Forgot Password?</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100"
                                            disabled={loading}
                                        >
                                            {loading ? 'Submitting...' : 'Sign In'}
                                        </button>
                                    </div>
                                    <div className="form-setlogin or-text">
                                        <h4>OR</h4>
                                    </div>
                                    <div className="mt-2">
                                        <div className="d-flex align-items-center justify-content-center flex-wrap">
                                            <div className="text-center me-2 flex-fill">
                                                <a className="br-10 p-2 btn btn-info d-flex align-items-center justify-content-center">
                                                    <img className="img-fluid m-1" src="assets/img/icons/facebook-logo.svg" alt="Facebook" />
                                                </a>
                                            </div>
                                            <div className="text-center me-2 flex-fill">
                                                <a className="btn btn-white br-10 p-2  border d-flex align-items-center justify-content-center">
                                                    <img className="img-fluid m-1" src="assets/img/icons/google-logo.svg" alt="Facebook" />
                                                </a>
                                            </div>
                                            <div className="text-center flex-fill">
                                                <a className="bg-dark br-10 p-2 btn btn-dark d-flex align-items-center justify-content-center">
                                                    <img className="img-fluid m-1" src="assets/img/icons/apple-logo.svg" alt="Apple" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                                        <p>Copyright © 2025 CWI</p>
                                    </div>
                                    <Link to='/dashboard'><button>dsah</button></Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`
                    .checkbox-container {
                        position: relative;
                        padding-left: 28px;
                        cursor: pointer;
                        user-select: none;
                        display: inline-block;
                    }

                    .checkbox-container input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        height: 0;
                        width: 0;
                    }

                    .checkmark {
                        position: absolute;
                        top: 3px;
                        left: 0;
                        height: 18px;
                        width: 18px;
                        background-color: #eee;
                        border-radius: 4px;
                        border: 1px solid #ccc;
                        transition: all 0.2s ease;
                    }

                    .checkbox-container input:checked ~ .checkmark {
                        background-color: #2980b9;
                        border-color: #2980b9;
                    }

                    .checkmark:after {
                        content: "";
                        position: absolute;
                        display: none;
                    }

                    .checkbox-container input:checked ~ .checkmark:after {
                        display: block;
                    }

                    .checkbox-container .checkmark:after {
                        left: 6px;
                        top: 2px;
                        width: 5px;
                        height: 10px;
                        border: solid white;
                        border-width: 0 2px 2px 0;
                        transform: rotate(45deg);
                    }
                `}
            </style>

        </>
    )
}